<template>
  <div class="w-full">
    <div class="tabs-wrapper overflow-x-auto scrollbar-hide">
      <div class="tabs-container flex border-b border-gray-200">
        <button
          v-for="(tab, index) in tabs"
          :key="tab.value"
          @click="selectTab(tab.value)"
          class="tab-button relative px-4 py-3 whitespace-nowrap transition-all duration-200 touch-manipulation"
          :class="[
            modelValue === tab.value
              ? 'text-gray-900 font-medium'
              : 'text-gray-500 font-normal hover:text-gray-700'
          ]"
        >
          {{ tab.label }}
          <span v-if="tab.count !== undefined" class="ml-1">({{ tab.count }})</span>

          <!-- Animated underline -->
          <span
            class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 transition-all duration-300"
            :class="[
              modelValue === tab.value
                ? 'opacity-100 scale-x-100'
                : 'opacity-0 scale-x-0'
            ]"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Tab {
  label: string;
  value: string;
  count?: number;
}

interface Props {
  tabs: Tab[];
  modelValue: string;
}

interface Emits {
  (e: 'update:modelValue', value: string): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const selectTab = (value: string) => {
  emit('update:modelValue', value);
};
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Smooth scrolling on mobile */
.tabs-wrapper {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* Improve touch targets on mobile */
.tab-button {
  -webkit-tap-highlight-color: transparent;
  min-height: 44px; /* iOS recommended minimum touch target */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Prevent text selection on touch */
.tab-button {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
